import React, { Component } from 'react'
import { Flex } from 'hljd'
import { hashHistory } from 'react-router'
import mainStore from '@components/Main/store'
import style from './style.module.less'
import { observer } from 'mobx-react'
import { Auth } from '@common/Auth'
import {
  PRIVILEGE_STORE_ID,
  PRIVILEGE_STORE_SERVICE_ID,
  ACCOUNT_MANAGE_PATH
} from '@constant'

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@observer
export default class extends Component {
  render() {
    const { is_bond_user } = mainStore.shopInfo

    return is_bond_user == 0 ? (
      <Flex
        vc
        className={style.wechat}
        onClick={() => hashHistory.push(ACCOUNT_MANAGE_PATH)}
      >
        <img
          src="//qnm.hunliji.com/o_1d852i18h60n1943ss6i4anr99.png"
          style={{ width: 16, height: 16 }}
        />
        <span>绑定微信，不错过关键客户信息</span>
      </Flex>
    ) : null
  }
}
